export const aiImageTools: string[] = [
  'Midjourney',
  'DALL-E (OpenAI)',
  'Stable Diffusion',
  'Adobe Firefly',
  'Ideogram',
  'Grok (xAI)',
  'Other'
];
